import { render, staticRenderFns } from "./Commentable.vue?vue&type=template&id=0fec17a1&scoped=true&"
import script from "./Commentable.vue?vue&type=script&lang=ts&"
export * from "./Commentable.vue?vue&type=script&lang=ts&"
import style0 from "./Commentable.vue?vue&type=style&index=0&id=0fec17a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec17a1",
  null
  
)

export default component.exports